/**
 * MapCookie
 * 
 * Responsible for finding and parsing Marketing Automation Platform cookies.
 */
import CookieStore from "./storecookie";

export enum PardotTypeEnum {
    VisitorIdKey = 'VisitorIdKey',
    VisitorIdValue = 'VisitorIdValue',
    VisitorHashKey = 'VisitorHashKey',
    VisitorHashValue = 'VisitorHashValue',
}

export class MapCookie 
{


    public static getActiveDemand(store: CookieStore) : Array<string>
    {
        return store.get('activedemand_session_guid');
    }

    public static getActOn(store: CookieStore, valuesOnly: boolean) : Array<string> 
    {
        const allCookies = store.getAll();
        // sort cookie keys (alpha)
        // so we can be certain key at index N corresponds
        // to value at index N
        const keys = Object.keys(allCookies).sort();
        // check for any act-on cookies
        let cookies = [];
        for (let i = 0; i < keys.length; i ++) {
            const key = keys[i];
            if (key.match(/wp\d/)) {
                const value = store.get(key);
                if (typeof(value) === 'string') {
                    if (valuesOnly) {
                        cookies.push(value);
                    } else {
                        cookies.push(key);
                    }
                }
            }
        }
        return cookies;
    }

    public static getHubSpot(store: CookieStore) : Array<string>
    {
        return store.get('hubspotutk');
    }

    public static getPardotVisitor(store: CookieStore, type: PardotTypeEnum) : Array<string> 
    {
        let cookies = [];
        const allCookies = store.getAll();
        const keys = Object.keys(allCookies);
        for (let j = 0; j < keys.length; j ++) {
            const key = keys[j];
            if (key.match(/visitor_id[0-9]+/) && key.indexOf('hash') === -1) {
                const hashKey = `${key}-hash`;
                if (type === PardotTypeEnum.VisitorIdKey) {
                    cookies.push(key);
                }
                else if (type === PardotTypeEnum.VisitorIdValue) {
                    const visitorIds = store.get(key);
                    for (let k = 0; k < visitorIds.length; k ++) {
                        cookies.push(visitorIds[k]);
                    }
                }
                else if (type === PardotTypeEnum.VisitorHashKey) {
                    cookies.push(hashKey);
                }
                else if (type === PardotTypeEnum.VisitorHashValue) {
                    const hashValues = store.get(hashKey);
                    for (let v = 0; v < hashValues.length; v ++) {
                        cookies.push(hashValues[v]);
                    }
                }
            }
        }
        return cookies;
    }

    /**
     * Find marketing automation cookies for the supported platforms.
     * 
     * ActiveDemand, Act-On, Pardot.
     * 
     * @returns Record<string, Array<string>>
     */
    public static findAll() : Record<string, Array<string>>
    {

        const cookies: Record<string, Array<string>> = {};
        
        const store = new CookieStore();

        // check for activedemand tracking
        cookies['ad_sg'] = [];
        const activedemand = store.get('activedemand_session_guid');
        if (activedemand && typeof(activedemand) === 'string') {
            cookies['ad_sg'].push(activedemand);
        }

        const allCookies = store.getAll();
        const keys = Object.keys(allCookies);

        // check for any act-on cookies
        cookies['ao_wp'] = [];
        for (let i = 0; i < keys.length; i ++) {
            const key = keys[i];
            if (key.match(/wp\d/)) {
                const value = store.get(key);
                if (typeof(value) === 'string') {
                    cookies['ao_wp'].push(`${key}=${value}`);
                }
            }
        }

        // check for pardot visitor id/hash combos
        cookies['pd_v'] = [];
        for (let j = 0; j < keys.length; j ++) {
            const key = keys[j];
            if (key.match(/visitor_id[0-9]+/) && key.indexOf('hash') === -1) {
                const visitorId = store.get(key);
                const hashKey = `${key}-hash`;
                const visitorHash = store.get(hashKey);
                if (typeof(visitorId) === 'string' && typeof(visitorHash) == 'string') {
                    cookies['pd_v'].push(`${key}=${visitorId},${hashKey}=${visitorHash}`);
                }
            }
        }

        // check for hubspot utk cookie
        // https://legacydocs.hubspot.com/docs/methods/forms/submit_form
        cookies['hs_u'] = [];
        for (let k = 0; k < keys.length; k ++) {
            const key = keys[k];
            if (key === 'hubspotutk') {
                const utk = store.get(key);
                if (utk && typeof(utk) === 'string') {
                    cookies['hs_u'].push(utk);
                }
            }
        }

        return cookies;
    }

}